import { Stack } from "@mui/material";
import type { FC } from "react";
import {
	ClientBondInterestTypeEnum,
	type ClientPortfolioDetailBondResponseDTO,
	ClientPortfolioInvestmentFrequencyEnum,
	ClientPortfolioInvestmentTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import { DataRowCollapsible } from "web_myplann/Shared/Components/DataRowCollapsible";
import {
	dateFormatter,
	moneyFormatter,
} from "web_myplann/Shared/Utils/formatters";

type Props = {
	bonds: ClientPortfolioDetailBondResponseDTO[];
};

export const BondSection: FC<Props> = ({ bonds }) => {
	const { t } = useResource();

	return (
		<Stack>
			{bonds.map((bond, index) => {
				return (
					<DataRowCollapsible
						key={bond.id}
						label={`${t(Resources.PortfolioDetail.ToolHistory.purchase)} - ${dateFormatter(bond.issueDate)}`}
						defaultExpanded={index === 0}
					>
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Fund.type)}
							value={t(
								Resources.PortfolioDetail.ToolHistory.ActionType[
									ClientPortfolioInvestmentTypeEnum.Buy
								],
							)}
						/>
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Bond.issueDate)}
							value={dateFormatter(bond.issueDate)}
						/>
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Bond.maturityDate)}
							value={dateFormatter(bond.maturityDate)}
						/>
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Bond.value)}
							value={moneyFormatter(
								bond.price,
								t(
									Resources.PortfolioDetail.SharedLabels.Currency[
										bond.currency
									],
								),
							)}
						/>
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Bond.amount)}
							value={bond.count ? `${bond.count}` : ""}
						/>
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Bond.interestRate)}
							value={t(
								Resources.PortfolioDetail.ToolHistory.Bond.InterestType[
									bond.interestType ?? ClientBondInterestTypeEnum.Fixed
								],
							)}
						/>
						{bond.interestType !== ClientBondInterestTypeEnum.Nullable && (
							<DataRow
								label={t(Resources.PortfolioDetail.ToolHistory.Bond.frequency)}
								value={t(
									Resources.PortfolioDetail.ToolHistory.Fund.Frequency[
										bond.frequency ??
											ClientPortfolioInvestmentFrequencyEnum.Monthly
									],
								)}
							/>
						)}
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Bond.yield)}
							value={bond.yield ? `${bond.yield?.toString()} %` : ""}
						/>
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Bond.tax)}
							value={bond.tax ? `${bond.tax?.toString()} %` : ""}
						/>
						<DataRow
							label={t(Resources.PortfolioDetail.ToolHistory.Bond.fee)}
							value={moneyFormatter(
								bond.fee,
								t(
									Resources.PortfolioDetail.SharedLabels.Currency[
										bond.currency
									],
								),
							)}
						/>
					</DataRowCollapsible>
				);
			})}
		</Stack>
	);
};
